import router from '../../router';
import couponsApi from '../../api/coupons-api';


const RESOURCE_NAME = '/app/coupon';
const RESOURCE_NAME_PUBLIC = '/app/public/sales';

const coupons = {
    items: [],
    item: {},
    listSelect: [],
    popupSeeCoupon: false,
};

const mutations = {
    setItemsCoupon(state, payload) {
        state.items = payload.data;
    },

    setItemCoupon(state, payload) {
        state.item = payload;
    },

    setpopupSeeCoupon(state, payload) {
        state.popupSeeCoupon = payload;
    },
};


const actions = {
    createCoupon({ commit, dispatch }, { coupon, language }) {
        commit('loading', true);
        couponsApi.create(coupon, language).then(
            (response) => {
                commit('notifications', { title: 'fidelization.CouponCreated' });
                commit('loading', false);
                router.push({ name: 'coupons' });
                commit('showNotifications', true);
            },
            (error) => {
                if (error.toString().includes('409')) {
                  commit('notifications', { title: 'fidelization.CouponNotCreated', text:'Falta por rellenar algún campo', color: 'danger' });
                } else {
                  commit('notifications', { title: 'fidelization.CouponNotCreated', color: 'danger' });
                }
                commit('loading', false);
                commit('showNotifications', true);
            },
        );
    },

    editCoupon({ commit, dispatch }, { id, coupon, language }) {

        commit('loading', true);
        couponsApi.edit(id, coupon, language).then(
            (response) => {
                commit('notifications', { title: 'fidelization.CouponModified' });
                commit('loading', false);
                router.push({ name: 'coupons' });
                commit('showNotifications', true);
            },
            (error) => {
              if (error.toString().includes('409')) {
                commit('notifications', { title: 'fidelization.CouponNotModified', text: 'fidelization.CouponNotFields', color: 'danger' });
              } else {
                commit('notifications', { title: 'fidelization.CouponNotModified', color: 'danger' });
              }
                commit('loading', false);
                commit('showNotifications', true);
            },
        );
    },

    async refreshCoupons(context, { restaurant_id, language }) {
        if (!restaurant_id) {
            restaurant_id = this.getters.getCurrentRestaurant;
        }
        context.commit('loading', true);
        const res = await couponsApi.getAllByRestaurant(restaurant_id, language);
        context.commit('loading', false);

        context.commit('setItemsCoupon', res);
    },




    async getCoupons(restaurant_id, language) {
        if (!language) language = store.getters.getCurrentLanguage;
        const requestConfig = {
            headers: {

                'Content-Type': 'multipart/form-data',
                'X-localization': language,
            },
        };
        const res = await couponsApi.getAllByRestaurant(restaurant_id, language);
        context.commit('setItemsCoupon', res);
    },

    async getCoupon(context, { id, language }) {
        context.commit('loading', true);
        context.commit('setItemCoupon', {});
        const res = await couponsApi.getOne(id, language);

        context.commit('setItemCoupon', res.data[0]);
        context.commit('loading', false);

    },

    deleteCoupon({ commit, dispatch }, id) {
        commit('loading', true);
        couponsApi.delete(id).then(
            (response) => {
                dispatch('refreshCoupons', {});
                commit('notifications', { title: 'fidelization.CouponDeleted' });
                commit('loading', false);
                commit('showNotifications', true);
            },
            (error) => {
                commit('notifications', { title: 'fidelization.CouponNotDeleted', color: 'danger' });
                commit('loading', false);
                commit('showNotifications', true);
            },
        );
    },
};

const getters = {
    getCoupons: (state) => state.items,
    getCoupon: (state) => state.item,
    getpopupSeeCoupon: state => state.popupSeeCoupon
};

export default {
    state: coupons,
    mutations,
    actions,
    getters,
};
